import React, { Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import PageTitle from '../../../Layout/AppMain/PageTitle';
import { Row, Col, Card, Button, FormGroup, Input, Table, Modal, ModalBody, } from 'reactstrap';
import Select from 'react-select';
import 'rc-time-picker/assets/index.css';
import { connect } from 'react-redux';
import AuthModel from '../../../models/Auth';
import { LIST_USER_CLIENTS, LIST_USER_PORTALS } from '../../../actions/clients';
import { GET_REQUEST_DETAILS, GET_PORTAL_STAGES_STATUS, GET_ASSET_TYPE_LIST, ADD_RECEPTION_UPDATED_LIST } from '../../../actions/reception';
import { MASTER_REQUEST_STAGE_STATUSES } from '../../../actions/requestStageStatuses';
import { SELECT_TYPES } from '../../../helper/constant';
import moment from 'moment';
import { darkerGreyColor } from "../../../helper/utils";


const mapStateToProps = state => {
    return {
        userClients: state.clients.userClients,
        userPortals: state.clients.userPortals,
        requsetDetails: state.b2cCustomer.requestIdList,
        requestStageStatusesList: state.requestStageStatuses.requestStageStatusesList,
        portalStageStatList: state.b2cCustomer.portalStageStatList,
        assetTypeList: state.b2cCustomer.assetTypeList
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        LIST_USER_CLIENTS: (payload) => dispatch(LIST_USER_CLIENTS(payload)),
        LIST_USER_PORTALS: (userId, clientIdList) => dispatch(LIST_USER_PORTALS(userId, clientIdList)),
        GET_REQUEST_DETAILS: (payload) => dispatch(GET_REQUEST_DETAILS(payload)),
        GET_REQ_STAGE_STATUS: (payload) => dispatch(MASTER_REQUEST_STAGE_STATUSES(payload)),
        GET_PORTAL_STATUS: (payload) => dispatch(GET_PORTAL_STAGES_STATUS(payload)),
        GET_ASSET_TYPE_LIST: (payload) => dispatch(GET_ASSET_TYPE_LIST(payload)),
        updateReceptionDetails: (payload, finalPayload) => dispatch(ADD_RECEPTION_UPDATED_LIST(payload, finalPayload)),
    }
}

class Reception extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            recType: '',
            receptionType: this.props.location.state ? this.props.location.state.receptionType : null,
            selectStatusType: [],
            selectTrackNumber: this.props.location.state ? this.props.location.state.selectTrackNumber : SELECT_TYPES[1],
            selectAssetType: SELECT_TYPES[2],
            assetTypeOption: null,
            openModalAsset: false,
            isTrackNumberLoading: false,
            isTrackNumberEmpty: false,
            receivedDisable: false,
            selectedTrackNumberList: [],
            grossWeight: 0,
            setEmptyDate: '',
            requestIdState: null,
            requestDetailsOriginal: null,
            isEditMode: { status: false, rowKey: null }
        }
    }

    async componentDidMount() {
        await this.props.LIST_USER_CLIENTS(AuthModel.userId);
        if (this.props.userClients && this.props.userClients.length) {
            await this.props.LIST_USER_PORTALS(AuthModel.userId, this.props.userClients.map(item => item.clientId));
        }
        this.getAllRequestDetails()
        await this.props.GET_REQ_STAGE_STATUS()
        await this.props.GET_ASSET_TYPE_LIST()
    }

    getAllRequestDetails = async () => {
        const { selectStatusType } = this.state;
        let ids=[];
        if( selectStatusType && selectStatusType.length) {
            ids = (selectStatusType && selectStatusType.map(x=> {return x.value})) || [];
        } else {
            ids = [73, 80]
        }
        const payload = { statusIds: ids }
        await this.props.GET_REQUEST_DETAILS(payload)
        const requestOption = []
        this.props.requsetDetails && this.props.requsetDetails.forEach(item => {
            // if (item.carrierTrackingnumber !== null || selectStatusType.length) {
            if (item.carrierTrackingnumber !== null) {
                requestOption.push({
                    id: item.id,
                    value: item.carrierTrackingnumber,
                    label: `${item.carrierTrackingnumber} -- ${item.displayId}`,
                    clientId: item.clientId,
                    programId: item.programId,
                    displayId: item.displayId,
                    requestTypeId: item.requestTypeId,
                    requestType: item.requestType,
                    jobDescriptionNumber: item.jobDescriptionNumber
                })
            }
        })
        requestOption.sort((a, b) => parseFloat(b.id) - parseFloat(a.id))
        this.setState({
            requestOption: requestOption,
            selectTrackNumber: SELECT_TYPES[1],

        })
    }

    onSelectTrackNumber = async (selectTrackNumber) => {
        if (selectTrackNumber.value !== null) {
            const payload = {
                requestTypeId: selectTrackNumber.requestTypeId,
                programId: selectTrackNumber.programId
            }
            await this.props.GET_PORTAL_STATUS(payload);
            this.setState({
                selectTrackNumber,
                selectAssetType: SELECT_TYPES[2],
                dateMessage: ''
            }, () => {
                this.onSearch()
            });
        } else {
            this.setState({
                selectTrackNumber: SELECT_TYPES[1],
                selectAssetType: SELECT_TYPES[2],
                selectedTrackNumberList: [],
                isTrackNumberEmpty: false,
                messageToshow: '',
                setEmptyDate: '',
                dateMessage: ''
            })
        }
    }

    onSelectAssetType = async selectAssetType => {
        this.setState({ selectAssetType });
    }

    onChangeDate = (event) => {
        const { value } = event.target
        this.setState({
            setEmptyDate: value,
            dateMessage: ''
        })
    }

    onSearch = async () => {
        const { portalStageStatList, requsetDetails } = this.props
        const { selectTrackNumber } = this.state
        const stageStatus = []
        let latReqStatProg, statReachFac = null
        if (portalStageStatList && portalStageStatList.length) {
            portalStageStatList.forEach(ele => {
                stageStatus.push({
                    requestTypeId: ele.requestTypeId,
                    statusId: ele.statusId,
                    description: (ele.statusInfo && ele.statusInfo.description) || '',
                    name: (ele.statusInfo && ele.statusInfo.name) || '',
                })
            })
            if (selectTrackNumber !== '' && selectTrackNumber !== null) {
                requsetDetails.forEach(item => {
                    if (selectTrackNumber.id === item.id) {
                        let dateCheck = (item.receivedDate === null ? '' : parseInt(item.receivedDate))
                        if (item.requestStatusProgress && item.requestStatusProgress.length) {
                            latReqStatProg = item.requestStatusProgress.reduce(function (r, a) {
                                return r.statusUpdatedDate > a.statusUpdatedDate ? r : a;
                            });
                            statReachFac = item.requestStatusProgress.filter(ele => ele.description === 'Reached Facility')
                            this.setState({
                                currentRequestStat: latReqStatProg.description || ''
                            })
                        }
                        if (selectTrackNumber.requestType === 'Process with prepaid label1' && (latReqStatProg && !latReqStatProg.description)) {
                            this.setState({
                                currentRequestStat: 'Pickup Date Assigned'
                            })
                        }
                        this.setState({
                            requestDetailsOriginal: item, // user for homecustomer details to update
                            requestIdState: item.id,
                            itemReceived: false,
                            isEditMode: { status: false, rowKey: null },
                            setEmptyDate: moment(dateCheck).format('YYYY-MM-DD'),
                        })
                        const tempItem = item.newRequestAssets
                        let calWeight = tempItem && tempItem.reduce(function (prev, current) {
                            return prev + +current.weight
                        }, 0)
                        this.setState({
                            selectedTrackNumberList: tempItem,
                            grossWeight: calWeight
                        })
                        if (item.b2cCustomer === true) {
                        // if (this.state.receptionType.value === 1) {
                            if (statReachFac.length) {
                                this.setState({
                                    messageToshow: `<span style="color: green;">Item received</span>`,
                                    isTrackNumberEmpty: true,
                                    itemReceived: true,
                                })
                            } else {
                                if (latReqStatProg) {
                                    const curStatusId = latReqStatProg.statusId
                                    stageStatus.find((ele, index) => {
                                        if (ele.statusId === curStatusId) {
                                            this.currentRequestStatConst = ele.description
                                            let searchIndex = index + 1
                                            if (stageStatus.length > searchIndex) {
                                                if (stageStatus[searchIndex].description === 'Reached Facility') {
                                                    this.setState({
                                                        currentRequestStat: this.currentRequestStatConst,
                                                        nextStatusIndex: searchIndex,
                                                        newStatusId: stageStatus[searchIndex].statusId,
                                                        messageToshow: `<span style="color: green;">Item can be received now</span>`,
                                                        isTrackNumberEmpty: true,
                                                    })
                                                } else {
                                                    let uppercaseStat = this.currentRequestStatConst.toUpperCase();
                                                    this.setState({
                                                        messageToshow: `<span style="color: red;">Item is in ${uppercaseStat}, Cannot be received until next stage is REACHED FACILITY</span>`,
                                                        isTrackNumberEmpty: false, itemReceived: true, currentRequestStat: this.currentRequestStatConst
                                                    })
                                                }
                                            } else {
                                                this.setState({
                                                    messageToshow: `<span style="color: green;">Item received</span>`,
                                                    isTrackNumberEmpty: true,
                                                    itemReceived: true,
                                                })
                                            }
                                        } return 0
                                    })

                                }
                            }
                        } else {
                            const tempHome = []
                            if (item.newRequestAssets && item.newRequestAssets.length) {
                                item.newRequestAssets.forEach(ele => {
                                    tempHome.push(ele)
                                })
                            } else {
                                tempHome.push({
                                    requestId: item.id,
                                    assetName: item.assetType,
                                    manufacturer: item.brand === 'Other' ? item.otherBrand : item.brand,
                                    serial: item.serial || '',
                                    weight: item.weight,
                                    quantity: item.quantity || 1,
                                    receivedAsset: false
                                })
                            }
                            let calWeight = tempHome.reduce(function (prev, current) {
                                return prev + +current.weight
                            }, 0)

                            this.setState({
                                selectedTrackNumberList: tempHome,
                                grossWeight: calWeight,
                            })
                            if (statReachFac && statReachFac.length) {
                                this.setState({
                                    messageToshow: `<span style="color: green;">Item received</span>`,
                                    isTrackNumberEmpty: true,
                                    itemReceived: true,
                                })
                            } else {
                                if (latReqStatProg) {
                                    const curStatusId = latReqStatProg.statusId
                                    stageStatus.find((ele, index) => {
                                        if (ele.statusId === curStatusId) {
                                            this.currentRequestStatConst = ele.description
                                            let searchIndex = index + 1
                                            if (stageStatus.length > searchIndex) {
                                                if (stageStatus[searchIndex].description === 'Reached Facility') {
                                                    this.setState({
                                                        currentRequestStat: this.currentRequestStatConst,
                                                        nextStatusIndex: searchIndex,
                                                        newStatusId: stageStatus[searchIndex].statusId,
                                                        messageToshow: `<span style="color: green;">Item can be received now</span>`,
                                                        isTrackNumberEmpty: true,
                                                    })
                                                } else {
                                                    let uppercaseStat = this.currentRequestStatConst.toUpperCase();
                                                    this.setState({
                                                        messageToshow: `<span style="color: red;">Item is in ${uppercaseStat}, Cannot be received until next stage is REACHED FACILITY</span>`,
                                                        isTrackNumberEmpty: false, itemReceived: true, currentRequestStat: this.currentRequestStatConst
                                                    })
                                                }
                                            } else {
                                                this.setState({
                                                    messageToshow: `<span style="color: green;">Item received</span>`,
                                                    isTrackNumberEmpty: true,
                                                    itemReceived: true,
                                                    isTrackNumberLoading: true
                                                })
                                            }
                                        } return 0
                                    })

                                }
                            }
                        }
                    }
                    const tempOption = [SELECT_TYPES[2]]
                    this.props.assetTypeList && this.props.assetTypeList.forEach(item => {
                        if (item.assetType !== null) {
                            tempOption.push({
                                value: item.id,
                                label: item.name,
                            })
                        }
                    })
                    this.setState({ assetTypeOption: tempOption })
                })
            }
        }
    }

    createPortalUrl = () => {
        if (this.state.selectTrackNumber) {
            this.props.history.push({
                pathname: '/dashboard/LabelPage',
                state: {
                    reqId: this.state.selectTrackNumber.id, compLoc: true,
                    selectTrackNumber: this.state.selectTrackNumber, 
                    // receptionType: this.state.receptionType
                }
            })
        }
    }

    onClickAdd = async () => {
        if (!this.state.itemReceived) {
            if (this.state.selectAssetType !== '' && this.state.selectAssetType !== null && this.state.selectAssetType.value !== null) {
                this.state.selectedTrackNumberList.push({
                    requestId: this.state.requestIdState,
                    assetName: this.state.selectAssetType.label,
                    serial: null,
                    manufacturer: null,
                    weight: 0,
                    quantity: 1
                })
                let rowLength = this.state.selectedTrackNumberList.length - 1
                this.setState({
                    selectedTrackNumberList: this.state.selectedTrackNumberList,
                    selectAssetType: SELECT_TYPES[2],
                    isEditMode: {
                        status: true,
                        rowKey: rowLength
                    }
                })
            }
        } else {
            this.setState({
                openModalAsset: true,
                // receivedDisable: true
            })
        }
    }

    onConfirmApprove = async (val) => {
        this.setState({
            itemReceived: !val,
            openModalAsset: false
        })
        if (val && this.state.selectAssetType !== '' && this.state.selectAssetType !== null && this.state.selectAssetType.value !== null) {
            this.state.selectedTrackNumberList.push({
                requestId: this.state.requestIdState,
                assetName: this.state.selectAssetType.label,
                serial: null,
                manufacturer: null,
                weight: 0,
                quantity: 1
            })
            let rowLength = this.state.selectedTrackNumberList.length - 1
            this.setState({
                selectedTrackNumberList: this.state.selectedTrackNumberList,
                selectAssetType: SELECT_TYPES[2],
                isEditMode: {
                    status: true,
                    rowKey: rowLength
                }
            })
        } else {
            this.setState({
                selectAssetType: SELECT_TYPES[2],
            })
        }
    }

    handleOnChange(index, dataType, value) {
        const newState = this.state.selectedTrackNumberList.map((item, i) => {
            if (i === index) {
                return { ...item, [dataType]: value };
            }
            return item;
        });
        this.setState({
            selectedTrackNumberList: newState,
        }, () => {
            if (dataType === 'weight') {
                this.updateGrossWeight()
            }
        })
    }

    updateGrossWeight = async () => {
        let sum = 0
        this.state.selectedTrackNumberList.forEach(ele => {
            if (ele.weight === null || ele.weight === '') {
                sum = sum + 0
            } else {
                sum = sum + parseFloat(ele.weight, 10)
            }
        })
        this.setState({
            grossWeight: sum
        })
    }

    onClickDelete = async (index) => {
        const reducedArray = [...this.state.selectedTrackNumberList];
        reducedArray.splice(index, 1);
        this.setState({ selectedTrackNumberList: reducedArray })
    }

    onClickSave = async () => {
        const {selectedTrackNumberList, setEmptyDate} = this.state
        if (setEmptyDate === "Invalid date" || setEmptyDate === "") {
            this.setState({ dateMessage: 'Select Received Date' })
        } else {            
            let date = Date.parse(setEmptyDate.toString())
            if (selectedTrackNumberList.length) {
                let finalPayload = {
                    id: this.state.requestIdState,
                    statusId: this.state.newStatusId,
                    newStatusId: this.state.newStatusId,
                    nextStatusIndex: this.state.nextStatusIndex,
                    statusRemakrs: '',
                    statusDescription: 'Reached Facility',
                    rejectRemarks: '',
                    isStatusApproved: true,
                    requestId: this.state.requestIdState,
                    updatedBy: AuthModel.userId,
                    tesBDM: AuthModel.username,
                    jobDescriptionNumber: this.state.selectTrackNumber.jobDescriptionNumber,
                    newStatusName: 'Reached Facility',
                    updatedDate: new Date().getTime(),
                    receivedDate: date,
                    receivedBy: AuthModel.username,
                }
                if (this.state.selectTrackNumber.b2cCustomer === true) {
                // if (this.state.receptionType.value === 1) {
                    const newRequestAssets = []
                    selectedTrackNumberList.forEach(item => {
                        newRequestAssets.push(item)
                    })
                    let date = Date.parse(setEmptyDate.toString())
                    const requestDetails = {
                        id: this.state.requestIdState,
                        grossWeight: this.state.grossWeight,
                        receivedDate: date,
                    }
                    const payload = {
                        requestDetails: requestDetails,
                        newRequestAssets: newRequestAssets,
                    }
                    await this.props.updateReceptionDetails(payload, finalPayload)
                } else {
                    const data = selectedTrackNumberList[0]
                    const requestDetails = {
                        id: data.requestId,
                        assetType: data.assetName,
                        brand: data.manufacturer,
                        weight: data.weight,
                        quantity: data.quantity,
                        grossWeight: this.state.grossWeight,
                        receivedDate: date,
                    }
                    const newRequestAssets = []
                    selectedTrackNumberList.forEach((item) => {
                        newRequestAssets.push(item)
                    })
                    const payload = {
                        requestDetails: requestDetails,
                        newRequestAssets: newRequestAssets,
                    }
                    await this.props.updateReceptionDetails(payload, finalPayload)
                }
                this.setState({
                    selectTrackNumber: SELECT_TYPES[1],
                    selectAssetType: SELECT_TYPES[2],
                    isTrackNumberEmpty: false,
                    selectedTrackNumberList: [],
                    grossWeight: 0,
                    setEmptyDate: '',
                    currentRequestStat: '',
                    messageToshow: ''
                });
                this.getAllRequestDetails()
            }
        }
    }

    onEdit = async (index) => {
        let controlsEnabled = this.state.isEditMode.status
        if (this.state.isEditMode.rowKey === index) {
            this.setState({ isEditMode: { status: !controlsEnabled, rowKey: index } })
        } else {
            this.setState({ isEditMode: { status: true, rowKey: index } })
        }
    }

    displayClientName = (clientId) => {
        const clientData = this.props.userClients.find((x) => {
            return parseInt(x.clientId) === parseInt(clientId)
        })
        if (!clientData && !clientData.clientInfo) {
            return '--';
        }
        return (clientData && clientData.clientInfo.name) || '--'
    }

    displayPortalName = (programId) => {
        const portalData = this.props.userPortals.find((x) => {
            return parseInt(x.programId) === parseInt(programId)
        })
        if (!portalData) {
            return '--';
        }
        return (portalData && portalData.portalInfo.name) || '--'
    }

    setReceivedAsset = (index) => {
        const updatedReceivedAsset = this.state.selectedTrackNumberList.map((obj, indx) => {
            if (indx === index) {
                return { ...obj, receivedAsset: !obj.receivedAsset };
            }
            return obj;
        });
        const bolVal = updatedReceivedAsset.some(x => x.receivedAsset === true)
        this.setState({
            selectedTrackNumberList: updatedReceivedAsset,
            receivedDisable: bolVal
        })
    }

    onSelectStatus = (selectStatusType) => {
        this.setState({
            selectStatusType
        }, () => {
            this.getAllRequestDetails();
        });
    }

    render() {
        const statusOption = [];        
        this.props.requestStageStatusesList && this.props.requestStageStatusesList.length && this.props.requestStageStatusesList.forEach(item => {
            statusOption.push({
                value: item.id,
                label: item.name
            })
        });

        return (
            <Fragment>
                <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <PageTitle heading="Reception" subheading="Here you will see all Request" icon="pe-7s-box2 icon-gradient bg-ripe-malin" />
                    <Card style={{ padding: "20px" }}>
                        <div className="px-5 py-4">
                            <FormGroup className="row" style={{ zIndex: 3, marginTop: "10px" }}>
                                <Row style={{ width: '100%', justifyContent: 'space-between' }}>
                                    <Col xl={4} >
                                        <FormGroup>
                                            <Select aria-label="Tracking Number" value={this.state.selectTrackNumber} onChange={this.onSelectTrackNumber} options={this.state.requestOption} autoFocus/>
                                        </FormGroup>
                                    </Col>
                                    <Col xl={4} >
                                        <FormGroup>
                                            <Select aria-label="Select Status" name="selectStatusType" placeholder="Status Type" options={statusOption} value={this.state.selectStatusType} onChange={this.onSelectStatus} isMulti />
                                        </FormGroup>
                                    </Col>
                                    <Col xl={4} >
                                        {this.state.selectTrackNumber.displayId ?
                                            (<div className="" style={{ display: "grid", fontSize: '17px', height: '35px', alignItems: 'center' }}>
                                                <span>Label Details:<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => this.createPortalUrl()}>{this.state.selectTrackNumber.displayId}</span></span>
                                                <span>Current Status: <span style={{ color: 'limegreen' }}>{this.state.currentRequestStat}</span></span>
                                                <span>Circle/Epicor Order Number: <span>{this.state.selectTrackNumber.jobDescriptionNumber}</span></span>
                                                <span>Client/Portal: <span>{this.displayClientName(this.state.selectTrackNumber.clientId)}/{this.displayPortalName(this.state.selectTrackNumber.programId)}</span></span>
                                            </div>) : null
                                        }
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                {this.state.isTrackNumberEmpty ?
                                    (<Row>
                                        <Col xl={4} >
                                            <FormGroup>
                                                <Select value={this.state.selectAssetType} aria-label="Select Asset Type" styles={darkerGreyColor} onChange={this.onSelectAssetType} options={this.state.assetTypeOption} />
                                            </FormGroup>
                                        </Col>
                                        <Col xl={2}>
                                            <Button className="btn btn-primary" style={{
                                                background: "#033C73 linear-gradient(180deg, #295988, #033C73) repeat-x",
                                                color: " #fff",
                                                borderColor: "#033C73"
                                            }} onClick={this.onClickAdd}>Add Assets</Button>
                                        </Col>
                                    </Row>) : null}
                            </FormGroup>

                            {this.state.messageToshow ?
                                (<Col>
                                    <div className="" style={{ fontSize: '17px', height: '35px', alignItems: 'center' }}
                                        dangerouslySetInnerHTML={{ __html: this.state.messageToshow }}>
                                    </div>
                                </Col>) : null
                            }
                            <Col>
                                <Table bordered size="sm">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Asset Type</th>
                                            <th>Brand</th>
                                            <th>Serial Number</th>
                                            <th>Quantity</th>
                                            <th>Weight</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.isTrackNumberLoading ?
                                            (<tr className="tbl_row text-center"><td className="text-center font-weight-bold text-info" style={{ fontSize: "30px" }} colSpan={6}>Loading...</td></tr>)
                                            : null
                                        }
                                        {!this.state.isTrackNumberLoading && (this.state.selectedTrackNumberList && this.state.selectedTrackNumberList.length === 0) ?
                                            (<tr className="text-center"><td colSpan={6}>No Data</td></tr>) :
                                            !this.state.isTrackNumberLoading && this.state.selectedTrackNumberList && this.state.selectedTrackNumberList.map((item, index) => (
                                                <tr key={index} className="onHoverList">
                                                    <td key={index}>
                                                        <input type="checkbox" placeholder="check" checked={item.receivedAsset} name="addAsset" onChange={() => this.setReceivedAsset(index)} disabled={this.state.itemReceived}/>
                                                    </td>
                                                    <td className="align-middle">{item.assetName}</td>
                                                    <td className="align-middle">
                                                        {this.state.isEditMode.status && this.state.isEditMode.rowKey === index ? (
                                                            <input type='text' aria-label="Manufacturer" className='form-control' step='1' min="1" value={item.manufacturer}
                                                                onChange={(e) => this.handleOnChange(index, 'manufacturer', e.target.value)}/>) : 
                                                            (item.manufacturer)
                                                        }
                                                    </td>
                                                    <td className="align-middle">
                                                        {this.state.isEditMode.status && this.state.isEditMode.rowKey === index ? (
                                                            <input type='text' aria-label="serial" className='form-control' step='1' min="1" value={item.serial}
                                                                onChange={(e) => this.handleOnChange(index, 'serial', e.target.value)}/>) : 
                                                            (item.serial)
                                                        }
                                                    </td>
                                                    <td className="align-middle">{item.quantity}</td>
                                                    <td className="align-middle">
                                                        {this.state.isEditMode.status && this.state.isEditMode.rowKey === index ? (
                                                            <input type='text' aria-label="weight" className='form-control' step='1' min="1" value={item.weight}
                                                                onChange={(e) => this.handleOnChange(index, 'weight', e.target.value)} />) : 
                                                            (item.weight)
                                                        }
                                                    </td>
                                                    <td className="align-middle">
                                                        {this.state.isEditMode.status && this.state.isEditMode.rowKey === index ?
                                                            <Button title="Save" color="primary" size="sm" className="mr-3" onClick={() => this.onEdit(index)}><span className="tes-save"></span></Button> :
                                                            <Button title="Edit" color="primary" size="sm" className="mr-3" onClick={() => this.onEdit(index)} disabled={this.state.itemReceived}><span className="tes-edit"></span></Button>
                                                        }
                                                        {(this.state.isEditMode.status && this.state.isEditMode.rowKey === index && index > 0) &&
                                                            <Button title="Delete" size="sm" color="danger" onClick={() => this.onClickDelete(index)} >
                                                                <span className="tes-trash"></span>
                                                            </Button>
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        {!this.state.isTrackNumberLoading && (this.state.selectedTrackNumberList && this.state.selectedTrackNumberList.length > 0) ?
                                            <tr>
                                                <td colSpan={4} />
                                                <td className="align-middle"><b>Gross Weight(total)</b>: {this.state.grossWeight}</td>
                                            </tr> : null
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </div>
                        <div className="px-5 py-4">
                            <FormGroup className="row">
                                <Col xl={2}>
                                    <label className="my-2 sm-bold">Received Date <span className="mendet">*</span></label>
                                </Col>
                                <Col xl={4}>
                                    <Input type="date" aria-label="Receipt Date" name="receiptDate" onChange={this.onChangeDate} value={this.state.setEmptyDate} disabled={this.state.itemReceived} />
                                    {this.state.dateMessage ?
                                        <span style={{ color: 'red' }}>{this.state.dateMessage}</span> :
                                        null
                                    }
                                </Col>
                                <Col xl={6}>
                                    {this.state.itemReceived && this.state.isTrackNumberEmpty ?
                                        <Button color="primary" className="btn-custom" disabled>Completed</Button>
                                        : this.state.isTrackNumberEmpty &&
                                        <Button color="primary" className="btn-custom" onClick={this.onClickSave} disabled={!this.state.receivedDisable}>Received</Button>
                                    }
                                </Col>
                            </FormGroup>
                        </div>
                    </Card>
                    <Modal isOpen={this.state.openModalAsset}>
                        <ModalBody className="text-center py-4">
                            <Row>
                                <Col>
                                    <span>This Tracking Number is Received, Still you need to Proceed!!! </span>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xs="3"></Col>
                                <Col xs="3">
                                    <Button color="primary" size="sm" block onClick={() => this.onConfirmApprove(true)}>Yes</Button>
                                </Col>
                                <Col xs="3">
                                    <Button color="primary" size="sm" block onClick={() => this.onConfirmApprove(false)}>No</Button>
                                </Col>
                                <Col xs="3"></Col>
                            </Row>
                        </ModalBody>

                    </Modal>
                </CSSTransitionGroup>
            </Fragment>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Reception);